import React, { FC } from 'react';
//import imagePng from 'images/hero-right-3.png';
import imagePng from 'images/platten fokep-min.jpg';
import HeroRealEstateSearchForm from 'components/HeroSearchForm/HeroRealEstateSearchForm';

export interface SectionHero2ArchivePageProps {
  className?: string;
  children?: React.ReactNode;
}

const SectionHero2ArchivePage: FC<SectionHero2ArchivePageProps> = ({
  className = '',
  children,
}) => {
  return (
    <div
      className={`nc-SectionHero2ArchivePage relative ${className}`}
      data-nc-id='SectionHero2ArchivePage'
    >
      <div className='absolute bottom-0 top-60 md:inset-y-0 w-5/6 xl:w-3/4 right-0 flex-grow'>
        <img
          className='absolute inset-0 object-cover w-full h-full'
          src={imagePng}
          alt='hero'
        />
      </div>
      <div className='relative flex flex-col-reverse items-start md:block pb-14 md:py-14 '>
        <div className='relative inline-flex'>
          <div className='w-screen right-10 md:right-32 inset-y-0 absolute bg-gradient-to-r from-cyan-500 to-[#2087aa] from-[#045e80]'></div>
          <div className='relative max-w-3xl inline-flex flex-shrink-0 flex-col items-start py-16 sm:py-20 space-y-8 sm:space-y-10 text-white'>
            <h2 className='font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%]'>
              Plattensee, Hungary
            </h2>
            <div className='flex items-center text-base md:text-lg '>
              <i className='text-2xl las la-map-marked'></i>
              <span className='ml-2.5'>Hungary </span>
              <span className='mx-5'></span>
              <i className='text-2xl las la-home'></i>
              <span className='ml-2.5'>100+ properties</span>
            </div>
          </div>
        </div>
        <div className='mb-10 md:mb-0 md:mt-10 w-full'>
          <HeroRealEstateSearchForm />
        </div>
      </div>
    </div>
  );
};

export default SectionHero2ArchivePage;
